
import React from 'react';
import { Routes, Route, useNavigate } from 'react-router-dom';
import WelcomeScreen from './pages/WelcomeScreen';
import CPFScreen from './pages/CPFScreen';
import CurriculoForm from './pages/CurriculoForm';
import SuccessScreen from './pages/SuccessScreen';
import AdminScreen from './pages/AdminScreen';
import AcessoProfissionalScreen from './pages/AcessoProfissionalScreen';
import SobreScreen from './pages/SobreScreen';
import DoacaoScreen from './pages/DoacaoScreen';
import ConfiguracoesScreen from './pages/ConfiguracoesScreen';
import { LogoMarca } from './components/MarcaCurriculo';

export default function App() {
  const navigate = useNavigate();
  return (
    <div className="container" style={{ position: 'relative' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10, flexWrap: 'wrap', gap: '8px' }}>
        <LogoMarca style={{ width: 80, cursor: 'pointer', flexShrink: 0 }} onClick={() => navigate('/')} />
        <div style={{ display: 'flex', alignItems: 'center', gap: '4px', flexWrap: 'wrap' }}>
          <button
            onClick={() => navigate('/doacao')}
            className="header-btn"
            style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '8px', borderRadius: '8px', transition: 'background 0.2s', display: 'flex', alignItems: 'center', gap: '6px', height: '44px' }}
            aria-label="Doação"
            title="Doação"
            onMouseEnter={(e) => e.currentTarget.style.background = '#f0f4f8'}
            onMouseLeave={(e) => e.currentTarget.style.background = 'none'}
          >
            <img src="/assets/icone-doacao.png" alt="Doação" style={{ width: 28, height: 28, opacity: 0.9 }} />
            <span className="header-btn-text" style={{ fontWeight: 600, color: 'var(--primary-color)', fontSize: '13px' }}>Doação</span>
          </button>
          <button
            onClick={() => navigate('/sobre')}
            className="header-btn"
            style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '8px', borderRadius: '8px', transition: 'background 0.2s', display: 'flex', alignItems: 'center', gap: '6px', height: '44px' }}
            aria-label="Nossa História"
            title="Nossa História"
            onMouseEnter={(e) => e.currentTarget.style.background = '#f0f4f8'}
            onMouseLeave={(e) => e.currentTarget.style.background = 'none'}
          >
            <img src="/assets/logos-07.svg" alt="Nossa História" style={{ width: 32, height: 32, opacity: 0.9 }} />
            <span className="header-btn-text" style={{ fontWeight: 600, color: 'var(--primary-color)', fontSize: '13px' }}>Nossa História</span>
          </button>
          <button
            onClick={() => navigate('/acesso-profissional')}
            className="header-btn"
            style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '8px', borderRadius: '8px', transition: 'background 0.2s', display: 'flex', alignItems: 'center', gap: '6px', height: '44px' }}
            aria-label="Acesso profissional"
            title="Acesso profissional"
            onMouseEnter={(e) => e.currentTarget.style.background = '#f0f4f8'}
            onMouseLeave={(e) => e.currentTarget.style.background = 'none'}
          >
            <img src="/assets/icones-curriculo-05.svg" alt="Acesso profissional" style={{ width: 26, height: 26, opacity: 0.8 }} />
            <span className="header-btn-text" style={{ fontWeight: 600, color: 'var(--primary-color)', fontSize: '13px' }}>Acesso Profissional</span>
          </button>
        </div>
      </div>
      <Routes>
        <Route path="/" element={<WelcomeScreen />} />
        <Route path="/sobre" element={<SobreScreen />} />
        <Route path="/doacao" element={<DoacaoScreen />} />
        <Route path="/acesso-profissional" element={<AcessoProfissionalScreen />} />
        <Route path="/cpf" element={<CPFScreen />} />
        <Route path="/curriculo" element={<CurriculoForm />} />
        <Route path="/sucesso" element={<SuccessScreen />} />
        <Route path="/admin" element={<AdminScreen />} />
        <Route path="/configuracoes" element={<ConfiguracoesScreen />} />
      </Routes>
    </div>
  );
}
